import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { m, LazyMotion, domAnimation } from "framer-motion";

const FeaturesSection = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  const features = [
    {
      icon: "bi-check-circle",
      titleKey: "featuresPage.feature1.title",
      descKey: "featuresPage.feature1.description",
    },
    {
      icon: "bi-person",
      titleKey: "featuresPage.feature2.title",
      descKey: "featuresPage.feature2.description",
    },
    {
      icon: "bi bi-check-circle",
      titleKey: "featuresPage.feature3.title",
      descKey: "featuresPage.feature3.description",
    },
    {
      icon: "bi-share",
      titleKey: "featuresPage.feature4.title",
      descKey: "featuresPage.feature4.description",
    },
    {
      icon: "bi-gift",
      titleKey: "featuresPage.feature5.title",
      descKey: "featuresPage.feature5.description",
    },
    {
      icon: "bi-bar-chart-line",
      titleKey: "featuresPage.feature6.title",
      descKey: "featuresPage.feature6.description",
    },
  ];

  return (
    <LazyMotion features={domAnimation}>
      <Container
        className="my-5"
        id="features"
      >
        <m.h2
          className="text-center mb-4 feature-title"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          style={{ color: "var(--primary-color)", willChange: "opacity" }}
        >
          {t("featuresPage.title")}
        </m.h2>
        <m.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <Row className="d-flex justify-content-center">
            {features.map((feature, index) => (
              <Col
                sm={12}
                md={6}
                lg={4}
                className="p-2"
                key={index}
              >
                <m.div
                  variants={itemVariants}
                  className="h-100"
                  style={{ willChange: "opacity" }}
                >
                  <Card
                    className="card-feature h-100 w-100 border-0"
                    style={{
                      backgroundColor: "var(--secondary-color)",
                      borderRadius: "16px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    <Card.Body className="text-start p-4 d-flex flex-column align-items-center text-center">
                      <div
                        className="mb-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: "60px",
                          height: "60px",
                          backgroundColor: "rgba(85, 38, 25, 0.1)",
                          borderRadius: "50%",
                          color: "var(--primary-color)",
                        }}
                      >
                        <i className={`bi ${feature.icon} fs-3`} />
                      </div>
                      <Card.Title
                        className="feature-text mb-2"
                        style={{ color: "var(--primary-color)", fontSize: "1.25rem" }}
                      >
                        {t(feature.titleKey)}
                      </Card.Title>
                      <Card.Text
                        className="feature-description"
                        style={{ color: "var(--text-light)" }}
                      >
                        {t(feature.descKey)}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </m.div>
              </Col>
            ))}
          </Row>
        </m.div>
      </Container>
    </LazyMotion>
  );
};

export default FeaturesSection;
